module.exports = __webpack_public_path__ + "img/black_small.7005dd56.gif";